import React from "react";
import "./Error_500.css";

function InternalServerError() {
  return (
    <div className="internalServerError">
      <h1 className="text">The site is currently unavailable :(</h1>
    </div>
  );
}

export default InternalServerError;
